module.exports = __webpack_public_path__ + "static/media/image.7f836890.svg";